import React, { useState } from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaGlobeAsia, FaPaperPlane, FaClock } from 'react-icons/fa';
import { contactAPI } from '../utils/api';
import toast from 'react-hot-toast';
import './Contact.css';

const COUNTRIES = ['UAE', 'Saudi Arabia', 'Kuwait', 'Qatar', 'Bahrain', 'Oman', 'Singapore', 'Malaysia', 'Libya'];
const COUNTRY_FLAGS = { 'UAE': '🇦🇪', 'Saudi Arabia': '🇸🇦', 'Kuwait': '🇰🇼', 'Qatar': '🇶🇦', 'Bahrain': '🇧🇭', 'Oman': '🇴🇲', 'Singapore': '🇸🇬', 'Malaysia': '🇲🇾', 'Libya': '🇱🇾' };

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await contactAPI.send(form);
      toast.success('Message sent! We\'ll get back to you shortly.');
      setSuccess(true);
      setForm({ name: '', email: '', phone: '', message: '' });
    } catch {
      toast.error('Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Hero */}
      <div className="contact-hero">
        <div className="container text-center">
          <div className="contact-badge"><FaEnvelope /> Get In Touch</div>
          <h1>Contact <span>Pavishna</span></h1>
          <p>Ready to start your international career journey? Our team is here to guide you every step of the way.</p>
        </div>
      </div>

      <div className="container">
        <div className="contact-grid">
          {/* Info Side */}
          <div className="contact-info">
            <h2>We're Here to Help</h2>
            <p>Whether you're looking for a job abroad or have questions about our process, reach out and we'll respond promptly.</p>

            <div className="info-cards">
              <div className="info-card">
                <div className="info-icon"><FaGlobeAsia /></div>
                <div>
                  <strong>Official Website</strong>
                  <a href="https://www.pavishnagroups.com" target="_blank" rel="noreferrer">www.pavishnagroups.com</a>
                </div>
              </div>
              <div className="info-card">
                <div className="info-icon"><FaEnvelope /></div>
                <div>
                  <strong>Email Us</strong>
                  <span>info@pavishnagroups.com</span>
                </div>
              </div>
              <div className="info-card">
                <div className="info-icon"><FaPhone /></div>
                <div>
                  <strong>Contact:</strong>
                 <li>  +91 9150126022 </li>
                  <li>  +91 8925233328  </li>
                </div>
              </div>
              <div className="info-card">
                <div className="info-icon"><FaClock /></div>
                <div>
                  <strong>Working Hours</strong>
                  <span>Mon – Sat: 9:30 AM – 6:00 PM</span>
                  <span>Sun: Closed</span>
                </div>
              </div>
            </div>

            <div className="countries-served-mini">
              <h3>Countries We Serve</h3>
              <div className="mini-countries">
                {COUNTRIES.map(c => (
                  <span key={c} className="mini-country">{COUNTRY_FLAGS[c]} {c}</span>
                ))}
              </div>
            </div>
          </div>

          {/* Form Side */}
          <div className="contact-form-card">
            {success ? (
              <div className="success-state">
                <div className="success-icon">✅</div>
                <h3>Message Sent!</h3>
                <p>Thank you for reaching out. Our team will get back to you within 24 hours.</p>
                <button className="btn-primary" onClick={() => setSuccess(false)}>Send Another Message</button>
              </div>
            ) : (
              <>
                <h3>Send Us a Message</h3>
                <form onSubmit={handleSubmit}>
                  <div className="form-row-2">
                    <div className="form-group">
                      <label>Full Name *</label>
                      <input className="form-control" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required placeholder="Your full name" />
                    </div>
                    <div className="form-group">
                      <label>Phone Number</label>
                      <input className="form-control" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} placeholder="+91 XXXXX XXXXX" />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input type="email" className="form-control" value={form.email} onChange={e => setForm({...form, email: e.target.value})} required placeholder="your@email.com" />
                  </div>
                  <div className="form-group">
                    <label>Message *</label>
                    <textarea className="form-control" rows={5} value={form.message} onChange={e => setForm({...form, message: e.target.value})} required placeholder="Tell us about yourself, your experience, and which country/role you're interested in..." />
                  </div>
                  <button type="submit" className="btn-primary w-full" disabled={loading}>
                    {loading ? 'Sending...' : <><FaPaperPlane /> Send Message</>}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>

        {/* Map placeholder */}
        <div className="map-section">
          <div className="map-placeholder">
            <div className="map-overlay">
              <FaMapMarkerAlt />
              <strong>Pavishna Global Services</strong>
              <span>Visit us or connect online</span>
              <a href="https://www.pavishnagroups.com" target="_blank" rel="noreferrer" className="btn-primary" style={{ marginTop: 12 }}>
                Visit Official Website
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
